import { Expense } from '@/shared/types';
import { authService } from '@/shared/services/realData/auth';

/**
 * Expense operations
 * Handles all expense-related database operations
 */
export const expenseService = {
  /**
   * Get all expenses for the current user
   */
  async getExpenses(): Promise<Expense[]> {
    const supabaseUserId = await authService.getCurrentUserSupabaseId();
    if (!supabaseUserId) throw new Error('User not authenticated or profile not found');

    // Use the expense service
    const { getExpenses } = await import('@/shared/services/services/expenseService');
    return getExpenses(supabaseUserId);
  },

  /**
   * Create a new expense
   */
  async createExpense(expenseData: Partial<Expense>): Promise<Expense> {
    const supabaseUserId = await authService.getCurrentUserSupabaseId();
    if (!supabaseUserId) throw new Error('User not authenticated or profile not found');

    // Use the expense service
    const { createExpense } = await import('@/shared/services/services/expenseService');
    return createExpense(supabaseUserId, expenseData as Omit<Expense, 'id' | 'created_at'>);
  },

  /**
   * Update an existing expense
   */
  async updateExpense(expense: Expense): Promise<void> {
    // Use the expense service
    const { updateExpense } = await import('@/shared/services/services/expenseService');
    await updateExpense(expense.id, expense);
  },

  /**
   * Delete an expense
   */
  async deleteExpense(expenseId: string): Promise<void> {
    // Use the expense service
    const { deleteExpense } = await import('@/shared/services/services/expenseService');
    await deleteExpense(expenseId);
  }
};
